import React, {useState, forwardRef, useImperativeHandle, useEffect} from 'react';
import PropTypes from 'prop-types';
import {PageGrid} from '@/component';
import {Modal, Divider, Card, Input, Button, Space} from 'antd';
import styles from './room.member.modal.module.less';
import {getColumns} from '@/page/customer/RoomPage/roomColumns';

const RoomMemberModal = forwardRef(({roomInfo}, ref) => {
    const [visible, setVisible] = useState(false);
    const [searchParam, setSearchParam] = useState(null);
    const [url, setUrl] = useState(null);

    useImperativeHandle(ref, () => ({
        open,
    }));
    const extra = (
        <Space.Compact>
            <Input style={{width: '50%'}} placeholder="请输入群成员名称" onChange={changeName} />
            <Button type="primary" onClick={search}>
                查询
            </Button>
        </Space.Compact>
    );
    const columns = getColumns(['memberName', 'type', 'joinScene', 'status']);
    useEffect(() => {}, [roomInfo]);

    function handleCancel() {
        setSearchParam(null);
        setVisible(false);
    }

    function handleOk() {
        setVisible(false);
    }

    function open() {
        setVisible(true);
        let {chatId} = roomInfo;
        const params = {name: '', chatId};
        setSearchParam(params);
        setUrl('/room/member/list');
    }

    function changeName(e) {
        let param = {...searchParam};
        param.name = e.target.value;
        setSearchParam(param);
    }

    function search() {
        let {chatId, name} = searchParam;
        setUrl(
            `/room/member/list?name=${encodeURIComponent(name)}&chatId=${encodeURIComponent(
                chatId
            )}`
        );
    }

    function renderTitle() {
        return (
            <div className={styles.header}>
                <p>{roomInfo.name || '未设置'}</p>
                <div>
                    <span className={styles.label}>群主：</span>
                    <span className={styles.value}>{roomInfo.ownerName}</span>
                    <Divider type="vertical" className={styles.divider} />
                    <span className={styles.label}>群公告：</span>
                    <span className={styles.value}>{roomInfo.notice || '未设置'}</span>
                </div>
            </div>
        );
    }

    return (
        <Modal
            width={'70%'}
            title={renderTitle()}
            open={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={null}
            destroyOnClose={true}
        >
            <Card extra={extra} style={{overflowY: 'auto'}} />
            {roomInfo && url && <PageGrid url={url} columns={columns} initParams={searchParam} />}
        </Modal>
    );
});

RoomMemberModal.displayName = 'RoomMemberModal';

RoomMemberModal.propTypes = {
    roomInfo: PropTypes.object,
};

export default RoomMemberModal;
